<template>
    <div class="ds-exchange-toolbar pt-2">
        <div class="ds-exchange-toolbar-left">
            <SearchInput v-model="search" class="w-[405px]" @input="onSearch" @clear="onClear" />
        </div>
        <div class="ds-exchange-toolbar-right">
            <div class="ds-exchange-toolbar-actions">
                <btn v-if="!archive" @click="onCreate">+ Создать</btn>
                <btn @click="emit('confirm')" type="secondary" class="ds-exchange-mass-response-button">
                    <icon class="ds-exchange-mass-response-icon" width="17" height="17" vb-size="24"><IconApprove /></icon>
                    <span>Подтвердить все</span>
                </btn>
            </div>
            <div class="ds-exchange-global-filter">
                <button type="button" class="ds-exchange-global-filter-trigger" :class="{ 'ds-exchange-global-filter-trigger-active': activeFiltersCount > 0 }" @click="emit('global-filter-click')">
                    <icon width="24" height="24" vb-size="17" class="ds-exchange-global-filter-icon"><IconFilter /></icon>
                    <span v-if="activeFiltersCount > 0" class="ds-exchange-global-filter-badge">{{ activeFiltersCount }}</span>
                </button>
            </div>
            <div class="ds-exchange-toolbar-toggle">
                <button type="button" class="ds-exchange-toolbar-icon-button" :class="{ 'ds-exchange-toolbar-icon-button-active': grid }" @click="toggleView">
                    <icon v-if="grid">
                        <IconList />
                    </icon>
                    <icon v-else>
                        <IconGrid />
                    </icon>
                </button>
            </div>
            <button type="button" class="ds-exchange-toolbar-icon-button" @click="emit('report')"><icon><IconDocExport /></icon></button>
        </div>
    </div>
</template>

<script setup lang="ts">
import SearchInput from '@/components/SearchInput.vue'
import { ref } from 'vue'
import IconGrid from '@/ui/icons/IconGrid.vue'
import IconList from '@/ui/icons/IconList.vue'
import IconDocExport from '@/ui/icons/IconDocExport.vue'
import IconFilter from '@/ui/icons/IconFilter.vue'
import IconApprove from '@/ui/icons/IconApprove.vue'

withDefaults(defineProps<{ archive?: boolean; activeFiltersCount?: number }>(), { archive: false, activeFiltersCount: 0 })

const search = ref('')
const grid = ref(false)
const emit = defineEmits(['search-input', 'create', 'changeView', 'report', 'confirm', 'global-filter-click'])

const onSearch = () => {
    emit('search-input', search.value)
}

const onClear = () => {
    search.value = ''
    onSearch()
}

const onCreate = () => {
    emit('create')
}

const toggleView = () => {
    grid.value = !grid.value
    emit('changeView', grid.value)
}


</script>
